export default "__VITE_ASSET__CVWiOa$i__"